import React from "react";

export default class FormSelect extends React.Component {
  static defaultProps = {
    type: "text",
    validation: false,
    placeholder: "",
    extraClass: "col mb-3",
    onChange: false,
    emptyOption: false,
    lbl: "",
    fieldVal: "cat_name",
    fieldId: "id",
    helpTxt: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedCategories: [],
      categoryLevels: [],
    };
  }

  componentDidMount() {
    if (this.props.initData) {
      this.setState({
        categoryLevels: [this.props.initData],
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initData !== this.props.initData && this.props.initData) {
      this.setState({
        categoryLevels: [this.props.initData],
      });
    }
  }

  handleCategoryChange = (level, value) => {
    const { onChange, fieldId } = this.props;
    const selectedCategories = [...this.state.selectedCategories];
    const categoryLevels = [...this.state.categoryLevels];

    // Update selected categories up to this level
    selectedCategories.length = level + 1;
    selectedCategories[level] = value;

    // Find the selected category's children
    const selectedCategory = this.findCategory(value, this.props.initData);

    if (
      selectedCategory &&
      (selectedCategory.children || selectedCategory.categories)
    ) {
      categoryLevels.length = level + 2;
      categoryLevels[level + 1] =
        selectedCategory.children || selectedCategory.categories;
    } else {
      categoryLevels.length = level + 1;
    }

    this.setState({ selectedCategories, categoryLevels });

    // Call parent onChange with the deepest selected category
    if (onChange) {
      onChange({
        target: {
          name: this.props.name,
          value: value ? parseInt(value, 10) : "",
        },
      });
    }
  };

  findCategory(id, categories) {
    if (!categories) return null;
    for (let category of categories) {
      if (category[this.props.fieldId].toString() === id.toString())
        return category;
      if (category.children) {
        const found = this.findCategory(id, category.children);
        if (found) return found;
      }
      if (category.categories) {
        const found = this.findCategory(id, category.categories);
        if (found) return found;
      }
    }
    return null;
  }

  renderSelectField(categories, level) {
    const { fieldId, fieldVal, validation, name } = this.props;

    if (!categories || categories.length === 0) return null;

    return (
      <div key={`level-${level}`} className="mt-2">
        <select
          id={`${name}-${level}`}
          name={`${name}-${level}`}
          value={this.state.selectedCategories[level] || ""}
          onChange={(e) => this.handleCategoryChange(level, e.target.value)}
          className={`block px-3.5 h-full py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
            validation && validation[name]
              ? "border-red-500"
              : "border-gray-300"
          }`}
        >
          <option value="">
            Selecteer {level === 0 ? "categorie" : "subcategorie"}
          </option>
          {categories.map((item) => (
            <option key={item[fieldId]} value={item[fieldId]}>
              {item[fieldVal]}
            </option>
          ))}
        </select>
      </div>
    );
  }

  render() {
    const { name, validation, lbl, helpTxt, extraClass } = this.props;
    const { categoryLevels } = this.state;

    return (
      <div className={extraClass}>
        <div className="flex items-center">
          <label
            htmlFor={name}
            className="block text-sm font-medium text-gray-700"
          >
            {lbl}
          </label>
          {helpTxt && (
            <div className="relative ml-1 group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                className="text-gray-400 cursor-pointer"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
              </svg>
              <div
                className="absolute top-6 left-1/2 invisible z-10 px-3 py-2 w-60 text-sm text-white bg-gray-800 rounded-lg opacity-0 transition-opacity duration-300 transform -translate-x-1/2 group-hover:visible group-hover:opacity-100"
                dangerouslySetInnerHTML={{ __html: helpTxt }}
              ></div>
            </div>
          )}
        </div>
        {categoryLevels.map((categories, index) =>
          this.renderSelectField(categories, index)
        )}
        {validation && validation[name] && (
          <p className="mt-2 text-sm text-red-600">{validation[name]}</p>
        )}
      </div>
    );
  }
}
